/*** IMPORTS FROM imports-loader ***/
var define = false;

import $ from 'jquery';


function injectVideo($injector) {
  const videoHtml = $injector.children('script').html();
  const $videoContainer = $injector.children('.video-container');
  if ($videoContainer.length) {
    $videoContainer.html(videoHtml);
  }
}

/**
 * Inject *all* videos in the container, regardless if they are in a modal or not.
 *
 * @param {HTMLElement} container
 */
function injectVideos(container) {
  const $container = $(container);
  if (!$container.length) {
    return;
  }

  $container.find('.js-video-injector').each((idx, injectorEl) => {
    injectVideo($(injectorEl));
  });
}

/**
 * Destroy injected videos in the container.
 *
 * @param {HTMLElement} container
 */
function destroyVideos(container) {
  const $container = $(container);
  if (!$container.length) {
    return;
  }

  $container.find('.js-video-injector').each((idx, injectorEl) => {
    $(injectorEl).children('.video-container').html('');
  });
}

/**
 * Inject videos in the container that are *not* in a modal.
 *
 * @param {HTMLElement} container
 */
function setupVideos(container) {
  const $container = $(container);
  if (!$container.length) {
    return;
  }

  $container.find('.js-video-injector').each((idx, injectorEl) => {
    const $injector = $(injectorEl);
    if (!$injector.closest('.reveal').length) {
      injectVideo($injector);
    }
  });
}

export { setupVideos, injectVideos, destroyVideos };

